import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NOTIFICATIONS_FEATURE_NAME, NotificationsState } from "./notifications.reducer";

export const selectorNotificationsState = createFeatureSelector<NotificationsState>(NOTIFICATIONS_FEATURE_NAME);

export const selectorNotifications = createSelector(selectorNotificationsState, (state) => state.notifications.data);
export const selectorNotificationsStatus = createSelector(selectorNotificationsState, (state) => state.notifications.status);
export const selectorNotificationsError = createSelector(selectorNotificationsState, (state) => state.notifications.error);

export const selectorUnreadCount = createSelector(selectorNotificationsState, (state) => state.unreadCount.data);
export const selectorUnreadCountStatus = createSelector(selectorNotificationsState, (state) => state.unreadCount.status);
export const selectorUnreadCountError = createSelector(selectorNotificationsState, (state) => state.unreadCount.error);

export const selectorMarkAllReadInFlight = createSelector(selectorNotificationsState, (state) => state.markAllReadInFlight);

